import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { FLUSH, PAUSE, PERSIST, persistReducer, persistStore, PURGE, REGISTER, REHYDRATE } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web


import productReducer from '../redux/Slices/productSlice';
import userReducer from '../redux/Slices/userSlice';
import { addressApi } from './APIs/addressApi';
import { authApi } from './APIs/authApi';
import { cartApi } from './APIs/cartApi';
import { paymentApi } from './APIs/paymentApi';
import { productApi } from './APIs/productApi';
import { userApi } from './APIs/userApi';

const userPersistConfig = {
  key: 'user',
  storage,
};

const rootReducer = combineReducers({
  user: persistReducer(userPersistConfig, userReducer),
  product: productReducer,
  [userApi.reducerPath]: userApi.reducer,
  [productApi.reducerPath]: productApi.reducer,
  [authApi.reducerPath]: authApi.reducer,
  [cartApi.reducerPath]: cartApi.reducer,
  [addressApi.reducerPath]: addressApi.reducer,
  [paymentApi.reducerPath]: paymentApi.reducer,
});

const toolkitStore = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }).concat(userApi.middleware, productApi.middleware, authApi.middleware, cartApi.middleware, addressApi.middleware, paymentApi.middleware),
});

export const persistor = persistStore(toolkitStore);

export default toolkitStore;
